var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`base-alert base-alert__${_vm.variant}`},[_c('span',{staticClass:"base-alert__message"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }